type SpacerProps = {
  height?: number;
  width?: number;
};

export const Spacer = ({ height = 0, width = 0 }: SpacerProps) => {
  return <div style={{ height: `${height}px`, width: `${width}px` }} />;
};
